import type { ReactNode } from 'react';
import React from 'react';

export interface ModalStateContextType {
  hideModal: () => void;
  setModal: (node: ReactNode, requireAuth?: boolean, dialogCn?: string) => void;
}

export const ModalStateContext = React.createContext<ModalStateContextType>({
  hideModal: () => {},
  setModal: () => {},
});
